import { DEGREE_TYPES } from "@/components/molecules/ProgramMenu/constants";
import { ALL_COUNTRIES } from "@/context/countries";
const SELECT_DEGREE = "Select Degree";
const NATIONAL_CODE = "+91";

const getProgramId = ({
  programId,
  associatedPrograms,
}: {
  programId: string;
  associatedPrograms: Array<ProgramDetails>;
}) => {
  if (!associatedPrograms.length) {
    return programId;
  } else {
    const firstObject = associatedPrograms[0];
    const programId = firstObject.attributes.BasicDetails.PROGRAM_ID;
    return programId;
  }
};

const getSpecializationValue = ({ associatedPrograms, program = "" }) => {
  if (!associatedPrograms.length) {
    return "";
  } else if (associatedPrograms.length === 1) {
    const firstObject = associatedPrograms[0];

    const specializationText = firstObject.attributes.BasicDetails.SpecializationText;
    return specializationText;
  } else {
    const selectedProgram = associatedPrograms.find(
      (p) =>
        p.attributes.BasicDetails?.Heading?.trim().toUpperCase() ===
        String(program).trim().toUpperCase(),
    );
    if (selectedProgram) {
      return selectedProgram.attributes.BasicDetails?.SpecializationText || "";
    }
    return "";
  }
};

const formatDate = (date) => {
  const pad = (n) => n.toString().padStart(2, "0");

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1); // months are 0-indexed
  const year = date.getFullYear();

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

const filterSelectedPrograms = ({
  associatedPrograms,
  degree = SELECT_DEGREE,
}: {
  associatedPrograms: Array<ProgramDetails>;
  degree: string;
}) => {
  return associatedPrograms.filter(
    (programOption) =>
      (programOption.attributes.BasicDetails?.ProgramType === DEGREE_TYPES[degree]?.id ||
        degree == SELECT_DEGREE) &&
      !!programOption.attributes.BasicDetails?.Heading
  );
};

const precedentSelectedPrograms = (associatedPrograms: Array<ProgramDetails>) =>
  associatedPrograms.map((selectedProgram) => selectedProgram.attributes.BasicDetails?.Heading?.toUpperCase() ?? ""
);

const getDefaultCountryCode = ({ isAffiliatePage = false }) => {
  return isAffiliatePage ? "+971" : NATIONAL_CODE;
}

const getCountryList = ({ isAffiliatePage = false }) => {
  return isAffiliatePage ? ALL_COUNTRIES?.filter(item => item.code !== "+91") : ALL_COUNTRIES;
}

export { 
  getProgramId, 
  getSpecializationValue, 
  formatDate, 
  filterSelectedPrograms, 
  precedentSelectedPrograms,
  getCountryList,
  getDefaultCountryCode
};
